import { MutationTree } from "vuex";
import { IHeaderState } from "@/store/modules/header/interface";

export default <MutationTree<IHeaderState>> {

	incrementMainButtonClickedKey(state) {
		state.mainButtonClickedKey++;
	},

	setMainButtonVisibility(state, v: boolean) {
		state.mainButtonVisibility = v;
	}

}